import  Vue from 'vue';
import _ from 'lodash';
import { constants, DEFAULT_ACTIVITY_TYPE, ACTIVITY_GLOBAL_COMPETITION, ACTIVITY_LOCAL_COMPETITION, ACTIVITY_SPECIFIC_PASSAGE } from 'config';

const state = {
    stepCount: 4,
    payload: {
        studentIds: [],
        quizCount: 5,
        mustPass: false,
        startDate: 1,
        passageId: null,
        dueDate: 7,
        essayEnabled: false,
        type: DEFAULT_ACTIVITY_TYPE,
        name: "Recurring Weekly Activity",
        competitionStartDate: null,
        competitionEndDate: null,
        team_name: null,
        dateRangeType:constants.dateRangeType.sevenDays,
        start_day: 2,
        start_hour: 8,
        due_day: 1,
        due_hour: 18,
        isWrittenResponseOn: false

//Contract example for Recurring Weekly Activity
          // "studentIds": [
          //     1775,
          //     1776
          // ],
          // "quizCount": 5,
          // "mustPass": false,
          // "passageId": null,
          // "essayEnabled": false,
          // "type": "FIXED_WEEKLY",
          // "name": "Recurring Weekly Activity(API TEST)",
          // "team_name": "Test T's Team",
          // "start_day": 1,
          // "start_hour": 8,
          // "due_day": 7,
          // "due_hour": 18

//for passage
  // "studentIds": [
  //     1775,
  //     1776
  // ],
  // "quizCount": 5,
  // "mustPass": false,
  // "startDate": 1686778588855,
  // "dueDate": 1688160988855,
  // "passageId": 1460,
  // "essayEnabled": true,
  // "type": "PASSAGE",
  // "name": "Assign Passage - \"Spooky Holidays around the World\"(TEST API)",
  // "team_name": "Test T's Team"

  //for competition
    // "studentIds": [
    //     1775,
    //     1776
    // ],
    // "quizCount": 5,
    // "mustPass": false,
    // "startDate": 1686951659871,
    // "dueDate": 1687642859871,
    // "passageId": null,
    // "essayEnabled": false,
    // "type": "LOCAL_COMPETITION",
    // "name": "Start a Competition(TEST API)",
    // "team_name": "Test T's Team"

    

    },
    activity_classes_by_ids: {},
    activity_student_ids: null,
    is_class_loading: false,
    isPremiumDialogOpened: false

}
const getters = {
    getIsLoading: state => state.is_class_loading,
    getActivityType: state => state.payload.type,
    isPremiumDialogOpened: state => state.isPremiumDialogOpened,
    getStepCount: state => state.stepCount,
    getSelectedStudents: state => {
        return state.payload.studentIds;
    },
    getPassageId: state => {
        return state.payload.passageId;
    },
    getPayload: state => {
        return state.payload;
    }
}
const mutations = {

    SET_IS_PREMIUM_DIALOG_OPENED(state, is_opened) {
        state.isPremiumDialogOpened = is_opened;
    },
    SET_ACTIVITY_TYPE(state, type) {
        Vue.set(state.payload, "type", type);
    },
     SET_STEP_COUNT(state, count) {
        state.stepCount = count;
     },


     SET_CLASS(state, clazz) {
        Vue.set(state.activity_classes_by_ids, clazz.id, clazz);
        let resultStudents = [];
            _.keys(state.activity_classes_by_ids).forEach(classId => {
                const activityClass = state.activity_classes_by_ids[classId];
                const checkedStudents = activityClass.selected_student_ids ? activityClass.selected_student_ids : [];
                resultStudents = resultStudents.concat(checkedStudents);
            });
        Vue.set(state.payload, "studentIds", resultStudents);
      },
    SET_ACTIVITY_STUDENTS(state, student_ids) {
    state.activity_student_ids = student_ids;
    },
    SET_CLASS_LOADING(state, is_loading) {
    state.is_class_loading = is_loading;
    },
    INIT_ACTIVITY_CLASSES(state) {
    state.activity_classes_by_ids = {};
    },
    updateQuizCount(state, count) {
      state.payload.quizCount = count;
    },
    updateMustPass(state, mustPass) {
      state.payload.mustPass = mustPass;
    },
    updatePassageId(state, passageId) {
      state.payload.passageId = passageId;
    },
    updateStartDay(state, startDay) {
      state.payload.start_day = startDay;
    },
    updateEndDay(state, endDay) {
      state.payload.due_day = endDay;
    },
    updateStartHour(state, startHour) {
      state.payload.start_hour = startHour;
    },
    updateEndHour(state, endHour) {
      state.payload.due_hour = endHour;
    },
    updateActivityName(state, name) {
      state.payload.name = name;
    },
    updateTeamName(state, teamName) {
      state.payload.team_name = teamName;
    },
    updateCompetitionDate(state, dateRange) {
      state.payload.competitionStartDate = dateRange.start;
      state.payload.competitionEndDate = dateRange.end;
    },
    updateDateRangeType(state, type) {
      state.payload.dateRangeType = type;
    },
    updateWrittenResponseOn(state, isOn) {
      state.payload.isWrittenResponseOn = isOn;
    },
    save(state, payload) {
      state = {
        ...payload
      }
    }
}
const actions = {
    /***
     * add/update activity_classes_by_ids with selected status
     * @param classId - the id of the class we want to select/unselect it and its all students.
     * @param checked - if set true, we make class and it's studnets to be selected with checked mark, otherwise make them to be unselected
     * @returns {void}
     */
    async selectClass({commit, dispatch}, { classId, checked }) {
      let clazz = { id: classId };
      if (state.activity_classes_by_ids[classId]) {
        clazz = _.cloneDeep(state.activity_classes_by_ids[classId]);
      }
  
      clazz.checked = checked;
      if (checked) {
        const fullClassObj = await dispatch('classes/getClass', { classId, withStudents: true }, {root: true});
        let students_list = [];
        if (fullClassObj.students_list) {
          students_list = fullClassObj.students_list;
        }
        clazz.selected_student_ids = students_list.map(student => student.id);
      } else {
        clazz.selected_student_ids = [];
      }
  
      commit('SET_CLASS', clazz);
    },
  
    /***
     * Select/unselect student for class
     * @param classId - the class id to select students inside it
     * @param studentId - the student id that should be selected/unselected with checked mark
     * @returns {void}
     */
    async selectClassStudent({ commit }, { classId, studentId, checked }) {
      let clazz = { id: classId };
      if (state.activity_classes_by_ids[classId]) {
        clazz = _.cloneDeep(state.activity_classes_by_ids[classId]);
      }
  
      let selectedStudentIds = clazz.selected_student_ids || [];
      if (checked) {
        if (!selectedStudentIds.includes(studId => studId === studentId)) {
          selectedStudentIds.push(studentId);
        }
      } else {
        selectedStudentIds = selectedStudentIds.filter(studId => studId !== studentId);
      }
      clazz.selected_student_ids = selectedStudentIds;
  
      commit('SET_CLASS', clazz);
    }, 
    initClassesForActivity(context, { activityItem, classes }) {
      const activity = activityItem ? activityItem :  null;
      if (!activity) return;
      console.log({classes});
      const newClasses = _.cloneDeep(classes);
      let activityClassIds = [];
      let checkedStudentIds = [];
      if (activity.type === ACTIVITY_LOCAL_COMPETITION) {
        activityClassIds = activity.classes.length > 0 ? activity.classes[0].studentAssignments.map(item => item.classId) : [];
      }
      newClasses.map(classItem => {
        let foundClass = null;
        if (activity.type === ACTIVITY_LOCAL_COMPETITION && activityClassIds.includes(classItem.classId)) {
        foundClass = activity.classes[0];
        } else {
        foundClass = activity.classes.find(item => item.classId === classItem.classId);
        }
        if (foundClass && classItem.students_list) {
        classItem.students_list.map(student => {
          const fIndex = foundClass.studentAssignments.findIndex(item => item.id === student.id && !checkedStudentIds.includes(student.id));
          if (fIndex >= 0)  {
            checkedStudentIds.push(student.id);
            student.checked = true;
          }
        })
        }
      });
      return newClasses;
    },
  }
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };